import { render } from "./App.vue?vue&type=template&id=2d17dd8a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2d17dd8a&lang=scss"

import exportComponent from "F:\\work\\frontend\\vue\\jp_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__